import React from "react";
// import { Dropdown } from "antd";
import { Menu, Dropdown } from "antd";
import classes from "./navTabs.module.css";
import SubMenu from "antd/lib/menu/SubMenu";
import { MenuItem } from "rc-menu";
import { FullscreenOutlined, ZoomInOutlined, RightOutlined, VerticalAlignTopOutlined, VerticalAlignBottomOutlined } from "@ant-design/icons";
import "./menu.css";
import { useFullView } from "../../utils/fullView";

export const ViewTab = () => {
  const isMobile = window.screen.width < 769;
  const [fullView, toggleFullView] = useFullView();

    // const passFunc = () => console.log('CLICKED');
    const elem = document.documentElement;
    const forZoom = (z) => {
      // const zoomSheet = document.getElementsByClassName('x-spreadsheet-table')[0];
      elem.style.zoom = z;
        // console.log(zoomSheet);
    };

    const forFullScreen = () => {
      console.log(elem);
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) { /* Safari */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) { /* IE11 */
        elem.msRequestFullscreen();
      }
    };

    const menu = (      
    <Menu className="file-menu">
      <MenuItem key="sub19" onClick={ toggleFullView }>
          <span className="file-menu-item"><span className="file-menu-item-left">{fullView ? <VerticalAlignBottomOutlined /> : <VerticalAlignTopOutlined />}</span><span className="file-menu-item-text">{fullView ? 'Show header' : 'Full view'}</span><span className="file-menu-item-shortcut">Ctrl+Shift+F</span></span>
        </MenuItem>
      <MenuItem key="sub20" onClick={ forFullScreen }>
          <span className="file-menu-item"><span className="file-menu-item-left"><FullscreenOutlined /></span><span className="file-menu-item-text">Full screen</span></span>
        </MenuItem>
      <SubMenu key="sub21" popupClassName="file-menu-submenu" title={<span className="file-menu-item"><span className="file-menu-item-left"><ZoomInOutlined /></span><span className="file-menu-item-text">Zoom</span><span className="file-menu-item-arrow"><RightOutlined /></span></span>}>
      <MenuItem key="sub21.1" onClick={() => forZoom("100%")}>
          <span className="file-menu-item"><span className="file-menu-item-left"><ZoomInOutlined /></span><span className="file-menu-item-text">100%</span></span>
        </MenuItem>
      <MenuItem key="sub21.2" onClick={() => forZoom("125%")}>
          <span className="file-menu-item"><span className="file-menu-item-left"><ZoomInOutlined /></span><span className="file-menu-item-text">125%</span></span>
        </MenuItem>
      <MenuItem key="sub21.3" onClick={() => forZoom("150%")}>
          <span className="file-menu-item"><span className="file-menu-item-left"><ZoomInOutlined /></span><span className="file-menu-item-text">150%</span></span>
        </MenuItem>
      <MenuItem key="sub21.4" onClick={() => forZoom("175%")}>
          <span className="file-menu-item"><span className="file-menu-item-left"><ZoomInOutlined /></span><span className="file-menu-item-text">175%</span></span>
        </MenuItem>
      </SubMenu>
    </Menu>
    );
    return (
    <Dropdown overlay={menu} trigger={["click"]} arrow>
        <div style={{fontSize:isMobile?'11px':'12px'}} className={classes.navTabButton} onClick={(e) => e.preventDefault()}>
            View
        </div>
    </Dropdown>
    );
};